import React, { createContext, useContext, useMemo } from 'react';

import { useHealthInformationCmsQuery } from '../../data/domains/config';

export type HealthInformationCmsContextValue = {
  isLoading: boolean;
  isAvailable: boolean;
  html: string;
  pageTitle: string;
  refetch: () => void;
};

const HealthInformationCmsContext = createContext<HealthInformationCmsContextValue | null>(null);

export function HealthInformationCmsProvider({ children }: { children: React.ReactNode }) {
  const query = useHealthInformationCmsQuery();

  const value = useMemo(
    (): HealthInformationCmsContextValue => ({
      isLoading: query.isPending,
      isAvailable: Boolean(query.data?.isAvailable),
      html: query.data?.html ?? '',
      pageTitle: query.data?.pageTitle ?? '',
      refetch: () => {
        void query.refetch();
      },
    }),
    [query.data?.html, query.data?.isAvailable, query.data?.pageTitle, query.isPending, query.refetch],
  );

  return <HealthInformationCmsContext.Provider value={value}>{children}</HealthInformationCmsContext.Provider>;
}

export function useHealthInformationCms(): HealthInformationCmsContextValue {
  const ctx = useContext(HealthInformationCmsContext);
  if (!ctx) {
    throw new Error('useHealthInformationCms must be used within HealthInformationCmsProvider');
  }
  return ctx;
}
